import { all } from 'redux-saga/effects';
import appSaga from './app/saga';
import loginSaga from './loginSystem/saga';
import notificationSaga from './notificationSystem/saga';
import ppiSaga from './PpiContainer/saga';
import ppsiSaga from './PpsiContainer/saga';
import dishSaga from './DishContainer/saga';
import ingredientSaga from './IngredientContainer/saga';
import imageSaga from './imageSystem/saga';
import utensilSaga from './UtensilContainer/saga';
import feedbackSaga from './FeedbackContainer/saga';
import marketSettingsSaga from './MarketSettingContainer/saga';

export default function* rootSaga() {
  yield all([
    ...appSaga,
    ...loginSaga,
    ...notificationSaga,
    ...ppiSaga,
    ...ppsiSaga,
    ...dishSaga,
    ...ingredientSaga,
    ...imageSaga,
    ...utensilSaga,
    ...feedbackSaga,
    ...marketSettingsSaga
  ]);
}
